import { render, staticRenderFns } from "./TrafficLicenseCreate.vue?vue&type=template&id=4c238a0f"
import script from "./TrafficLicenseCreate.vue?vue&type=script&lang=js"
export * from "./TrafficLicenseCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports